'use client';

import AppImage from '@/components/ui/AppImage';

interface BrandPhoto {
  id: string;
  src: string;
  alt: string;
  brand: string;
  label: string;
}

const brandPhotos: BrandPhoto[] = [
{
  id: 'photo_elf',
  src: '/assets/images/IMG_8673-1774395882109.jpeg',
  alt: 'Mary Bellakbira in collaboration with e.l.f. Cosmetics beauty campaign',
  brand: 'e.l.f. Cosmetics',
  label: 'Beauty & Skincare'
},
{
  id: 'photo_kendra_scott',
  src: '/assets/images/IMG_8674-1774396251912.jpeg',
  alt: 'Mary Bellakbira wearing Kendra Scott jewelry in brand partnership',
  brand: 'Kendra Scott',
  label: 'Jewelry & Lifestyle'
},
{
  id: 'photo_palmers',
  src: '/assets/images/IMG_8676-1774396031325.jpeg',
  alt: "Mary Bellakbira featuring Palmer's Vanilla Bliss PR package in brand collaboration",
  brand: "Palmer's",
  label: 'Skincare'
},
{
  id: 'photo_born_to_stand_out',
  src: '/assets/images/IMG_8677-1774396903374.jpeg',
  alt: 'Mary Bellakbira collaborating with Born to Stand Out fragrance brand',
  brand: 'Born to Stand Out',
  label: 'Fashion & Lifestyle'
},
{
  id: 'photo_emporio_armani',
  src: '/assets/images/IMG_8678-1774395622011.jpeg',
  alt: 'Mary Bellakbira in Emporio Armani brand partnership campaign',
  brand: 'Emporio Armani',
  label: 'Luxury Fashion'
},
{
  id: 'photo_bubble_poppi',
  src: '/assets/images/IMG_8675-1774396152891.jpeg',
  alt: 'Mary Bellakbira in Bubble x Poppi brand collaboration campaign',
  brand: 'Bubble x Poppi',
  label: 'Beauty & Wellness'
}];


export default function BrandPhotosGallerySection() {
  return (
    <section className="py-20 px-6 bg-secondary">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-muted-foreground mb-4">
            Brand Collaborations
          </span>
          <h2 className="text-4xl font-bold text-foreground mb-4">
            Partnerships in Action
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">A glimpse into authentic collaborations with leading brand, from beauty and fashion to lifestyle and luxury.

          </p>
        </div>

        {/* Masonry-style Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {brandPhotos.map((photo, index) =>
          <div
            key={photo.id}
            className={`group relative overflow-hidden rounded-2xl shadow-sm hover:shadow-xl transition-all duration-500 bg-white border border-border ${
            index === 0 || index === 5 ? 'sm:col-span-1' : ''}`
            }>

              {/* Photo */}
              <div className="relative aspect-[4/5] overflow-hidden">
                <AppImage
                src={photo.src}
                alt={photo.alt}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105" />

                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300" />

                {/* Brand Label */}
                <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-1 group-hover:translate-y-0 transition-transform duration-300">
                  <span className="inline-block text-xs font-semibold tracking-widest uppercase text-white/70 mb-1">
                    {photo.label}
                  </span>
                  <h3 className="text-xl font-bold text-white leading-tight">
                    {photo.brand}
                  </h3>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-14">
          <p className="text-muted-foreground text-base">
            Interested in collaborating? email: maryambellakbira@gmail.com
          </p>
        </div>
      </div>
    </section>);

}